import { Box, CircularProgress, Typography } from '@mui/material';
import { LocalSeoAllSx } from './localSeoCss';

export const LoaderModal = () => {
  return (
    <>
      <Box
        sx={{
          flexDirection: 'column',
          padding: '24px',
          gap: '16px',
          ...LocalSeoAllSx?.localSeoLoader
        }}
      >
        <CircularProgress size={44} />

        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 400,
            fontSize: 'var(--font-size-18)',
            lineHeight: 'var(--line-height-24)',
            textAlign: 'center',
            color: 'var(--color-text-secondary)'
          }}
        >
          {'Fetching data please wait...'}
        </Typography>
      </Box>
    </>
  );
};
